var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAuditLog = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "auditlog-a",
  points: "0 -.001 12.037 -.001 12.037 9 0 9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 2)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11 5L6 5C5.447 5 5 4.553 5 4 5 3.447 5.447 3 6 3L11 3C11.553 3 12 3.447 12 4 12 4.553 11.553 5 11 5M10 9L6 9C5.447 9 5 8.553 5 8 5 7.447 5.447 7 6 7L10 7C10.553 7 11 7.447 11 8 11 8.553 10.553 9 10 9M14 5L14 5C13.447 5 13 4.553 13 4 13 3.447 13.447 3 14 3 14.553 3 15 3.447 15 4 15 4.553 14.553 5 14 5M6 13L6 13C5.447 13 5 12.553 5 12 5 11.447 5.447 11 6 11 6.553 11 7 11.447 7 12 7 12.553 6.553 13 6 13"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8 10)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "auditlog-b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#auditlog-a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.1133,4.5 C7.1133,3.879 6.6233,3.375 6.0183,3.375 C5.4143,3.375 4.9253,3.879 4.9253,4.5 C4.9253,5.121 5.4143,5.625 6.0183,5.625 C6.6233,5.625 7.1133,5.121 7.1133,4.5 M6.0183,7.313 C4.5083,7.313 3.2833,6.054 3.2833,4.5 C3.2833,2.946 4.5083,1.687 6.0183,1.687 C7.5293,1.687 8.7553,2.946 8.7553,4.5 C8.7553,6.054 7.5293,7.313 6.0183,7.313 M11.6403,3.604 L8.7383,1.042 C7.1633,-0.348 4.8753,-0.348 3.3003,1.042 L0.3963,3.604 C-0.1317,4.07 -0.1317,4.93 0.3963,5.396 L3.3003,7.958 C4.8753,9.348 7.1633,9.348 8.7383,7.958 L11.6403,5.396 C12.1703,4.93 12.1703,4.07 11.6403,3.604",
  mask: "url(#auditlog-b)"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M17,8 L17,6 L17,2.001 C17,0.896 16.104,0 14.999,0 L2,0"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M3,3 L1.5,3 C0.672,3 0,2.328 0,1.5 C0,0.672 0.672,0 1.5,0 C2.328,0 3,0.672 3,1.5 L3,6 L3,15 C3,16.104 3.896,17 5,17 L6,17"
}))));
export default SvgAuditLog;